module.exports = __webpack_public_path__ + "img/6.467c73a1.png";